module.exports = __webpack_public_path__ + "img/Mehr_Eghtesad.2dc125bf.svg";